import { Draft, produce } from 'immer';

import {
  CONTRACT_SETUP__DOCUMENT_PARTICIPANTS_FETCH_REQUEST,
  CONTRACT_SETUP__DOCUMENT_PARTICIPANTS_FETCH_SUCCESS,
  CONTRACT_SETUP_ALL_STATE_CLEAR,
  CONTRACT_SETUP_BY_DRAFT_REQUEST,
  CONTRACT_SETUP_BY_DRAFT_SUCCESS,
} from '@app/store/actionTypes';
import {
  ContractSetupAction,
  contractSetupSetParticipants,
} from '@app/store/contract-setup/actions';

export type ContractSetupParticipantsIdsState = string[];

const initialState: ContractSetupParticipantsIdsState = [];

const reducer = produce(
  (
    draft: Draft<ContractSetupParticipantsIdsState>,
    action: ContractSetupAction
  ): Draft<ContractSetupParticipantsIdsState> => {
    switch (action.type) {
      case CONTRACT_SETUP_ALL_STATE_CLEAR:
      case CONTRACT_SETUP_BY_DRAFT_REQUEST:
      case CONTRACT_SETUP__DOCUMENT_PARTICIPANTS_FETCH_REQUEST:
        return initialState;
      case CONTRACT_SETUP__DOCUMENT_PARTICIPANTS_FETCH_SUCCESS: {
        const { participants } = action.payload;
        participants.forEach((participant) => {
          const { participantId } = participant;
          if (!draft.includes(participantId)) {
            draft.push(participantId);
          }
        });
        return draft;
      }
      case contractSetupSetParticipants.type: {
        return action.payload.map((participant) => participant.participantId);
      }

      case CONTRACT_SETUP_BY_DRAFT_SUCCESS: {
        const { participants } = action.payload;
        return participants.map((participant) => participant.id);
      }
      default:
        return draft;
    }
  },
  initialState
);

export default reducer;
